import { type ReactNode, useState } from "react";

import { ProfileContext } from "../lib/profile.js";
import { ProfileDialog } from "./ProfileDialog.js";

/**
 * Renders the player profile dialog once, inside the root route (`App.tsx`), and provides
 * `showProfile` to open it: a seat on any surface calls `useProfile().showProfile(seat.endUser.id)`.
 * It sits under the router, unlike `RevealClaimProvider`, because the dialog links to the Account
 * page.
 */
export function ProfileProvider({ children }: { children?: ReactNode }) {
  const [endUserId, setEndUserId] = useState<string | null>(null);

  return (
    <ProfileContext.Provider value={{ showProfile: setEndUserId }}>
      {children}
      <ProfileDialog endUserId={endUserId} onClose={() => setEndUserId(null)} />
    </ProfileContext.Provider>
  );
}
